import { AlertLevel } from '@jupiterone/jupiter-types';
import { FindingResult } from '@jupiterone/jupiter-web-toolkit';

export function getFindingLevel(finding: FindingResult) {
  if (finding?.properties?.severity) {
    return getLevelBySeverity(finding.properties.severity);
  } else if (finding?.properties?.numericSeverity) {
    return getLevelByNumericSeverity(finding.properties.numericSeverity);
  } else {
    return AlertLevel.INFO;
  }
}

export function getSeverityByLevel(level: AlertLevel) {
  switch (level) {
    case AlertLevel.INFO:
      return 2;
    case AlertLevel.LOW:
      return 4;
    case AlertLevel.MEDIUM:
      return 6;
    case AlertLevel.HIGH:
      return 8;
    case AlertLevel.CRITICAL:
      return 10;
    default:
      return 2;
  }
}

function getLevelBySeverity(severity: string): AlertLevel {
  const numericSeverity = parseInt(severity, 10);
  if (!numericSeverity) {
    if (!severity.toUpperCase) {
      return AlertLevel.INFO;
    }
    const alphaSeverity = severity.toUpperCase();
    let level = AlertLevel.INFO;
    Object.keys(AlertLevel).forEach((l: any) => {
      if (alphaSeverity.indexOf(l) >= 0) {
        level = l;
      }
    });
    return level;
  }
  return getLevelByNumericSeverity(numericSeverity);
}

function getLevelByNumericSeverity(numericSeverity: number): AlertLevel {
  if (numericSeverity <= 2) {
    return AlertLevel.INFO;
  } else if (numericSeverity <= 4) {
    return AlertLevel.LOW;
  } else if (numericSeverity <= 6) {
    return AlertLevel.MEDIUM;
  } else if (numericSeverity <= 8) {
    return AlertLevel.HIGH;
  } else if (numericSeverity > 8) {
    return AlertLevel.CRITICAL;
  } else {
    return AlertLevel.INFO;
  }
}
